import { useQuery } from '@tanstack/react-query';
import { apiService } from '@/api/services/ApiService';
import { useAuth } from '@/stores/authContext';

export const API_TOKEN_QUERY_KEY = ['apiToken'] as const;

// API-токен интеграции (server-state). Включён только при авторизации.
export function useApiToken() {
  const { isAuthenticated } = useAuth();
  return useQuery({
    queryKey: API_TOKEN_QUERY_KEY,
    queryFn: () => apiService.getToken(),
    enabled: isAuthenticated,
    staleTime: 5 * 60_000,
  });
}
